import { StringUtils } from 'src/app/services/utils/string.utils';

export class TaskScaiObject {

  constructor(private request: string, private response: string) {
  }

  static create(): TaskScaiObject {
    return new TaskScaiObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE);
  }

  public getRequest(): string {
    return this.request;
  }

  public getResponse(): string {
    return this.response;
  }
}
